import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildSocial } from '../../../lib/analytics';
import { formatNumber } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

const COLORS = ['#E25A3C', '#2F9D6A', '#C4A484', '#4C7CF3', '#9A8B7A', '#D97706'];

export default function SocialPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const social = buildSocial(ranged);
  const total = social.reduce((sum, s) => sum + s.value, 0);
  const columns = ['社交平台', '浏览量', '占比'];
  const rows = social.map((s) => [
    s.name,
    formatNumber(s.value),
    total ? `${((s.value / total) * 100).toFixed(1)}%` : '0%',
  ]);

  if (!currentSite) {
    return <EmptyState title="先添加一个站点" desc="添加站点后可拆解微博、知乎、小红书等社交来源。" />;
  }

  return (
    <div>
      <PageHeader
        title="社交媒体"
        desc="微博、知乎、小红书、抖音等社交平台带来的访问。"
        range={range}
        extra={<ExportButton filename={`${currentSite.domain}-social.csv`} columns={columns} rows={rows} />}
      />

      <div className="mt-6 grid grid-cols-1 xl:grid-cols-2 gap-4">
        <div className="rounded-lg border border-background-200 bg-background-50 p-5">
          <h2 className="text-sm font-semibold text-foreground-900">平台占比</h2>
          <div className="mt-4 h-72">
            {total === 0 ? (
              <p className="text-sm text-foreground-500">当前时段暂无社交媒体来源</p>
            ) : (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={social} dataKey="value" nameKey="name" innerRadius={60} outerRadius={100}>
                    {social.map((s, i) => (
                      <Cell key={s.name} fill={COLORS[i % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>
        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="px-5 py-3 border-b border-background-200">
            <h2 className="text-sm font-semibold text-foreground-900">平台明细</h2>
          </div>
          <StatTable columns={columns} rows={rows} empty="暂无社交来源" />
        </div>
      </div>
    </div>
  );
}
